(() => {
  if (window.ConceptLogoCarouselVisibilityInitialized) return;
  window.ConceptLogoCarouselVisibilityInitialized = true;

  const hideDelay = 1000;
  const hideTimers = new WeakMap();

  const initCarousel = (carousel) => {
    if (!(carousel instanceof HTMLElement)) return;
    if (carousel.dataset.logoCarouselVisibilityReady === 'true') return;

    const track = carousel.querySelector('[data-logo-carousel-track]');
    if (!(track instanceof HTMLElement)) return;

    carousel.dataset.logoCarouselVisibilityReady = 'true';

    track.addEventListener(
      'scroll',
      () => {
        carousel.classList.add('is-scrolling');

        const activeTimer = hideTimers.get(carousel);
        if (activeTimer) window.clearTimeout(activeTimer);

        const hideTimer = window.setTimeout(() => {
          carousel.classList.remove('is-scrolling');
          hideTimers.delete(carousel);
        }, hideDelay);

        hideTimers.set(carousel, hideTimer);
      },
      { passive: true }
    );
  };

  const init = (root = document) => {
    if (root instanceof HTMLElement && root.matches('[data-logo-carousel]')) {
      initCarousel(root);
    }

    root.querySelectorAll?.('[data-logo-carousel]').forEach(initCarousel);
  };

  init(document);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
